import { firma } from '../content';
import './business-card.css';

/**
 * Visitenkarte "Manuel Schneider Dienstleistungen", 85 x 55 mm.
 *
 * WARUM keine Rollenbezeichnung ausser "Inhaber": siehe content.ts
 * (Kopfkommentar) zu geschuetzten Berufsbezeichnungen. Die Karte nennt
 * deshalb bewusst nur "Inhaber".
 */
export function BusinessCard() {
  return (
    <div className="business-card-page">
      <div className="business-card" aria-label="Visitenkarte, Vorder- und Rueckseite">
        <div className="business-card__face business-card__face--front">
          <span className="business-card__bleed" aria-hidden="true" />
          <p className="business-card__wordmark">{firma.name}</p>
        </div>

        <div className="business-card__face business-card__face--back">
          <span className="business-card__bleed" aria-hidden="true" />
          <p className="business-card__name">{firma.inhaber}</p>
          <p className="business-card__role">Inhaber</p>
          <address className="business-card__address">
            {firma.strasse}
            <br />
            {firma.ort}
          </address>
          <p className="business-card__line">{firma.telefon}</p>
          {/* Eins-zu-eins-Kontakt: persoenliche Adresse, nicht die allgemeine. */}
          <p className="business-card__line">{firma.mailPersoenlich}</p>
          <p className="business-card__line">{firma.web}</p>
        </div>
      </div>
    </div>
  );
}
